import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { PeriodsManageService } from 'src/app/service/management/periods-manage.service';

@Component({
    selector: 'app-add-period-dialog',
    templateUrl: './add-period-dialog.component.html',
    styleUrls: ['./add-period-dialog.component.scss'],
    standalone: false
})
export class AddPeriodDialogComponent implements OnInit {
  heading: string;
  eventType: string;
  errormsg: string;
  periodData = [];
  oldPeriods = [];
  selected_period_id;
  selected_period_value
  periodId
  crossDockStart
  crossDockEnd
  midWestStart
  midWestEnd
  westCoastStart
  westCoastEnd

  modifiedcrossDockStart
  modifiedcrossDockEnd
  modifiedmidWestStart
  modifiedmidWestEnd
  modifiedwestCoastStart
  modifiedwestCoastEnd
  isPeriodDDDisabled = false;
  constructor(public dialogRef: MatDialogRef<AddPeriodDialogComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly constants: Constants,
    private readonly periodManageService: PeriodsManageService, private readonly ngxUiLoaderService : NgxUiLoaderService) { }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.periodData = this.dataStore?.periodData
    this.eventType = this.dataStore.eventType
    this.oldPeriods = this.dataStore.oldPeriods;
    this.selected_period_id = this.periodData[0]?.periodId;
    if (this.eventType == "EDIT") {  // NOSONAR
      this.periodId = this.dataStore.data.periodId
      this.isPeriodDDDisabled = true;
      this.selected_period_value = this.dataStore.data.period
      const match = this.periodData.find(x => x.periodId == this.dataStore.periodId);  // NOSONAR
      this.selected_period_id = match?.periodId ?? this.periodData[0]?.periodId;
      this.crossDockStart = this.dataStore.data.crossDockStart
      this.crossDockEnd = this.dataStore.data.crossDockEnd
      this.midWestStart = this.dataStore.data.midWestStart
      this.midWestEnd = this.dataStore.data.midWestEnd
      this.westCoastStart = this.dataStore.data.westCoastStart
      this.westCoastEnd = this.dataStore.data.westCoastEnd

      this.dateChangeToPicker("crossDockStart")
      this.dateChangeToPicker("crossDockEnd")
      this.dateChangeToPicker("midWestStart")
      this.dateChangeToPicker("midWestEnd")
      this.dateChangeToPicker("westCoastStart")
      this.dateChangeToPicker("westCoastEnd")

    }
  }
  dateChangeToPicker(key) {
    const tempPeriodDate = this[String(key)].split("-")
    if (tempPeriodDate)
      {this[String(key)] = tempPeriodDate[2] + '-' + tempPeriodDate[0] + '-' + tempPeriodDate[1]}
    this.dateChangeToAPI(key)
  }
  dateChangeToAPI(key) {
    const tempPeriodDate = this[String(key)].split('-');
    this[String("modified" + key)] = tempPeriodDate[1] + '-' + tempPeriodDate[2] + '-' + tempPeriodDate[0]
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  close(): void {
    this.dialogRef.close(
      { event: "CloseEvent" }
    );
  }
  public saveClick(): void {
  this.errormsg = "";

  if (!this.selected_period_id) {
    this.showError(this.constants.formInputError);
    return;
  }

  this.selected_period_value =
    this.periodData.find(x => x.periodId == this.selected_period_id)?.period;  // NOSONAR

  const isDuplicate = this.eventType != "EDIT" && this.oldPeriods.includes(this.selected_period_value); // NOSONAR

  if (isDuplicate) {
    this.showError("Period already present");
    return;
  }

  if (
    this.isValueOk(this.crossDockStart) ||
    this.isValueOk(this.crossDockEnd)
  ) {
    this.showError(this.constants.formInputError);
    return;
  }

  if (this.crossDockStart > this.crossDockEnd) {
    this.showError("Midwest Crossdock start date can not be greater than end date");
    return;
  }

  if (
    this.isValueOk(this.midWestStart) ||
    this.isValueOk(this.midWestEnd)
  ) {
    this.showError(this.constants.formInputError);
    return;
  }

  if (this.midWestStart > this.midWestEnd) {
    this.showError("PSC start date can not be greater than end date");
    return;
  }

  if (
    this.isValueOk(this.westCoastStart) ||
    this.isValueOk(this.westCoastEnd)
  ) {
    this.showError(this.constants.formInputError);
    return;
  }

  if (this.westCoastStart > this.westCoastEnd) {
    this.showError("NAMC start date can not be greater than end date");
    return;
  }

  this.ngxUiLoaderService.start(this.constants.LoaderComponent);

  const request$ =
    this.eventType == "ADD" // NOSONAR
      ? this.periodManageService.addPeriod(
          this.selected_period_id,
          this.modifiedcrossDockStart,
          this.modifiedcrossDockEnd,
          this.modifiedmidWestStart,
          this.modifiedmidWestEnd,
          this.modifiedwestCoastStart,
          this.modifiedwestCoastEnd
        )
      : this.periodManageService.editPeriod(
          this.periodId,
          this.modifiedcrossDockStart,
          this.modifiedcrossDockEnd,
          this.modifiedmidWestStart,
          this.modifiedmidWestEnd,
          this.modifiedwestCoastStart,
          this.modifiedwestCoastEnd
        );

  request$.subscribe(
    response => {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      if (response == "Success") {  // NOSONAR
        this.dialogRef.close({
          event: "SaveEvent",
          eventType: this.eventType,
          eventResponse: "Success"
        });
      } else {
        this.showError(this.constants.APIErrorMessage);
      }
    },
    () => {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      this.showError(this.constants.APIErrorMessage);
    }
  );
}



  showError(message) {
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = ""
    }, this.constants.notificationMessageTime);
  }

  isValueOk(param: any): boolean {
    if (param == undefined || param == null || param == "")  // NOSONAR
{
      return true;
}
    return false;
  }
}
